import { atom } from 'recoil';

/**
 * @deprecated Use the History API to navigate between paths
 */
export const paths = atom<string[]>({
  key: 'path-history_paths',
  default: [],
});
